
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/rollers/for-windows",
      function () {
        return require("private-next-pages/rollers/for-windows/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/rollers/for-windows"])
      });
    }
  